import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/demo/dashboard/DemoDashboardClient.tsx");
